<mat-dialog-content>
  <section>
    <h3>{{data.examName}}</h3>
    <h4>{{data.subject}}</h4>
    <h3>{{'EXAM_INFORMATION_DIALOG.TIME.TITLE' | translate}}</h3>

    <!-- <div class="w2c-columns is-vcentered">
    <div class="w2c-column w2c-column--title">
      {{'EXAM_INFORMATION_DIALOG.TIME.START_TIME' | translate}}
    </div>
    <div class="w2c-column">
      {{data.time.startTime}}
    </div>
  </div>
  <div class="w2c-columns is-vcentered">
    <div class="w2c-column w2c-column--title">
      {{'EXAM_INFORMATION_DIALOG.TIME.END_TIME' | translate}}
    </div>
    <div class="w2c-column">
      {{data.time.endTime}}
    </div>
  </div> -->
  @if (data.time.availableTime) {
    <ul>
      <li>
        {{'EXAM_INFORMATION_DIALOG.TIME.AVAILABLE_TIME' | translate}}
        <span class="time"> {{data.time.availableTime}} </span>
      </li>
    </ul>
  }
  @if (data.time.endTime) {
    <ul>
      <li>
        {{'EXAM_INFORMATION_DIALOG.TIME.END_TIME' | translate}}
        <span class="time"> {{data.time.endTime}} </span>
      </li>
    </ul>
  }
</section>
@if (data && data.attachments && data.attachments.length > 0) {
  <section>
    <h3>{{'EXAM_INFORMATION_DIALOG.ATTACHMENTS' | translate}}</h3>
    <ul>
      @for (attachment of data.attachments; track attachment) {
        <li>{{attachment}}</li>
      }
    </ul>
  </section>
}
<section>
  <h3>{{'EXAM_INFORMATION_DIALOG.DRAFTS.TITLE' | translate}}</h3>
  <ul>
    @if (data.drafts.allowed) {
      <li>{{'EXAM_INFORMATION_DIALOG.DRAFTS.ALLOWED' | translate}}</li>
    } @else {
      <li>{{'EXAM_INFORMATION_DIALOG.DRAFTS.NOT_ALLOWED' | translate}}</li>
    }
    @if (data.drafts.included) {
      <li>{{'EXAM_INFORMATION_DIALOG.DRAFTS.SAVED' | translate}}</li>
    } @else {
      <li>{{'EXAM_INFORMATION_DIALOG.DRAFTS.NOT_SAVED' | translate}}</li>
    }
  </ul>
</section>

<section>
  <h3>{{'EXAM_INFORMATION_DIALOG.AVAILABLE_FEATURES' | translate}}</h3>
  <ul id="feature-list">
    @for (feature of data.availableFeatures; track feature) {
      <li>
        {{'FEATURES.' + feature | translate}}
      </li>
    }
  </ul>
</section>
</mat-dialog-content>

<mat-dialog-actions [align]="">
  <button mat-button mat-dialog-close color="primary" (click)="confirm()">
    {{'COMMON.OK' | translate}}
  </button>
</mat-dialog-actions>